// Wait until the DOM is fully loaded
window.addEventListener('DOMContentLoaded', () => {
  console.log('Page loaded, checking saved cookie preferences.')

  // Define elements
  const cookieBanner = document.getElementById('cookie-banner')
  const cookiePreferencesOverlay = document.getElementById(
    'cookie-preferences-overlay'
  )
  const cookiePreferences = document.getElementById('cookie-preferences')
  const acceptAllButton = document.getElementById('accept-all-cookies')
  const managePreferencesButton = document.getElementById('manage-preferences')
  const savePreferencesButton = document.getElementById('save-preferences')
  const closePreferencesButton = document.getElementById('close-preferences')
  const essentialCookiesCheckbox = document.getElementById('essential-cookies')
  const analyticsCookiesCheckbox = document.getElementById('analytics-cookies')
  const marketingCookiesCheckbox = document.getElementById('marketing-cookies')

  // Load saved preferences from localStorage
  const storedPreferences = JSON.parse(
    localStorage.getItem('cookie-preferences')
  )
  if (storedPreferences) {
    console.log('Loaded saved preferences:', storedPreferences)
    essentialCookiesCheckbox.checked = storedPreferences.essential
    analyticsCookiesCheckbox.checked = storedPreferences.analytics
    marketingCookiesCheckbox.checked = storedPreferences.marketing
  } else {
    console.log('No saved preferences found.')
  }

  // Check if cookies have been accepted previously
  if (localStorage.getItem('cookies-accepted')) {
    console.log('Cookies already accepted, hiding banner.')
    cookieBanner.style.display = 'none'
  } else {
    console.log('Cookies not accepted yet, showing banner.')
  }

  // Show the preferences overlay when "Manage Preferences" is clicked
  managePreferencesButton.addEventListener('click', () => {
    console.log('Manage Preferences clicked. Showing preferences dialog.')
    cookieBanner.style.display = 'none'
    cookiePreferencesOverlay.classList.add('active')
  })

  // Save preferences and hide the preferences overlay
  savePreferencesButton.addEventListener('click', () => {
    const preferences = {
      essential: essentialCookiesCheckbox.checked,
      analytics: analyticsCookiesCheckbox.checked,
      marketing: marketingCookiesCheckbox.checked,
    }
    console.log('Saving preferences:', preferences)
    localStorage.setItem('cookie-preferences', JSON.stringify(preferences))
    cookiePreferencesOverlay.classList.remove('active')
  })

  // Close preferences overlay without saving
  closePreferencesButton.addEventListener('click', () => {
    console.log('Close Preferences clicked. Hiding preferences dialog.')
    cookiePreferencesOverlay.classList.remove('active')
    cookieBanner.style.display = 'flex'
  })

  // Accept all cookies and hide the banner
  acceptAllButton.addEventListener('click', () => {
    console.log('Accept All Cookies clicked. Accepting all cookies.')
    localStorage.setItem('cookies-accepted', 'true')
    cookieBanner.style.display = 'none'
  })

  // Close preferences overlay when clicked outside the preferences pane
  cookiePreferencesOverlay.addEventListener('click', (event) => {
    if (event.target === cookiePreferencesOverlay) {
      cookiePreferencesOverlay.classList.remove('active')
      cookieBanner.style.display = 'flex'
    }
  })
})
